import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ResponseSingle } from 'src/app/models/response.model';
import { Order, OrderResponse } from '../../../../models/order.model';
import { OrderService } from '../../services/order.service';
import { isPlatformBrowser } from '@angular/common';
import { ReportType } from '../../../../models/report.model';
import { Product } from '../../../../models/product.model';

@Component({
  selector: 'app-order-preview',
  templateUrl: './order-preview.component.html',
  styleUrls: ['./order-preview.component.scss'],
})
export class OrderPreviewComponent implements OnInit, OnDestroy {
  public order!: Order;
  public paymentRedirectUri?: string;
  // protected readonly window = window;
  public orderEditUrl: string = '';
  public reportType!: ReportType;
  public productPrice!: number;
  public products:Product[] = [];

  public productName: string ='';




  constructor(
    private _orderService: OrderService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _cd:ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit() {
    this.reportType = !!this._route.snapshot.url.find((item) =>
      item.path.includes('rozszerzony'),
    )
      ? ReportType.EXTENDED
      : ReportType.PRIMARY;


    this._orderService.getProducts().subscribe( (data) => {
      const products:Product[] = data.data;
      // this.products = data.data
      for (let product of products) {
          if(product.name == this.reportType) {
            this.productName = product.publicName
            this.productPrice = product.price.amount/100;
          }
      }

      this._cd.detectChanges();



      console.log(this.productPrice)

    })


    const orderId = this._route.snapshot.params['id'];
    let productPath = this.reportType === ReportType.PRIMARY? 'podstawowy' : 'rozszerzony';
    if (orderId && isPlatformBrowser(this.platformId)) {
      this._orderService.getOrder(orderId).subscribe((data) => {
        this.order = data.data;
        productPath = data.data.product.type === ReportType.PRIMARY ? 'podstawowy' : 'rozszerzony';
        this.orderEditUrl = `/zamowienie/${productPath}/${orderId}`;
      });
      this.paymentRedirectUri =
        this._orderService.orderResponse.getValue()?.data.redirectUri;
    } else {
      const currentState = this._router.lastSuccessfulNavigation;
      this.order = currentState?.extras?.state?.['data'];
      this.orderEditUrl = `/zamowienie/edytuj/${productPath}`;
    }
  }

  public onAcceptAndPay() {

    const order = {
      ...this.order,
      product: this.reportType,
    };
    this._orderService.orderRequest.next(order);

    if(isPlatformBrowser(this.platformId)) {

      this._orderService
        .createOrder(order)
        .subscribe({
          next: (data: ResponseSingle<OrderResponse>) => {
            this._orderService.orderResponse.next(data);
            const redirectUri = data?.data?.redirectUri;
            console.log('Redirect URI:', redirectUri);
            if (!redirectUri) {
              console.error('Missing redirectUri');
              return;
            }
            window.location.href = redirectUri;
          },
          error: (err) => {
            console.error('Create order failed', err);
          }
        });
      //
      // this._orderService
      //   .createOrder(order)
      //   .subscribe((data: ResponseSingle<OrderResponse>) => {
      //     this._orderService.orderResponse.next(data);
      //     this.paymentRedirectUri =
      //       this._orderService.orderResponse.getValue()?.data.redirectUri;
      //     this.goToUrl(this.paymentRedirectUri);
      //   });
    }

  }

  public goToUrl(url: string | undefined): void {

    if (!url) {
      return;
    }

    if (isPlatformBrowser(this.platformId)) {
      window.location.href = url;
    }
  }

  public navigate(url: string): void {
    const navigationExtras: NavigationExtras = {
      state: {
        data: this.order,
      },
    };

    this._router.navigate([url], navigationExtras);
  }

  ngOnDestroy() {
    this._orderService.orderRequest.unsubscribe();
  }
}
